import { observer } from 'mobx-react';
import { ExperienceResource } from '../Types';
import ExperiencePrice from './ExperiencePrice';
import ExperienceProductBadge from './ExperienceProductBadge';

interface Props {
  experienceResource: ExperienceResource;
}

function ExperienceFooter({ experienceResource }: Props) {
  return (
    <div className="flex w-full items-center justify-between">
      <ExperienceProductBadge experienceResource={experienceResource} />
      <ExperiencePrice />
    </div>
  );
}

export default observer(ExperienceFooter);
